export enum ButtonTheme {
  Primary = `primary`,
  Secondary = `secondary`,
  Tertiary = `tertiary`,
  Select = `select`,
}

export enum ButtonSize {
  Medium = `medium`,
  Large = `large`,
}

export enum ButtonType {
  Destructive = `destructive`,
  Info = `info`,
  Success = `success`,
  Warn = `warn`,
}
